import React from "react"
import QuestionsAnswers from "./QuestionsAnswers"
import { useFocusHeading } from "../../../lib/a11y/useFocusHeading"


const SliderItem = ({
    item,
    current,
    max,
    value,
    onSelectAnswer,
    onWaehle,
    aktiv = true,
}) => {

    const { name, question } = item
    // Wird die Folie aktiv, bekommt ihre Ueberschrift den Fokus (#178): sonst
    // bliebe er nach dem Beantworten auf der alten, versteckten Folie zurueck.
    // Ohne Scrollen: die Folie bringt der Slider selbst ins Bild (#220).
    const headingRef = useFocusHeading(aktiv, { preventScroll: true })

    return (
        <div className="jm-slide-item">
            <div className="jm-question-title">
                {/* Die Position steht im Namen der Ueberschrift, die beim Wechsel
                    den Fokus bekommt; der sichtbare Zaehler ist dafuer Dekoration.
                    Als Live-Region blieb er stumm — sein Text aendert sich nie (#236). */}
                <span aria-hidden="true">{current}/{max}</span>
                <h3 tabIndex={-1} ref={headingRef}>
                    <span className="jm-sr-only">{`Frage ${current} von ${max}: `}</span>{name}
                </h3>
            </div>
            <div className="jm-question-text">{question}</div>

            <QuestionsAnswers
                questionId={item._id}
                question={question}
                value={value}
                onAnswer={onSelectAnswer}
                onWaehle={onWaehle}
                aktiv={aktiv}
            />
        </div>
    )
}

export default SliderItem